import { TRIAL_TYPES } from 'utils/constants/trial';
import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';
import { preserveQueryParam } from 'functions/preserveQueryParam';
import { FILTER_CATEGORY, TREATMENT_TYPE_VALUES } from './constants';

const getIsDrugItem = ({ trialType }) => trialType === TRIAL_TYPES.TREATMENT;

export const filterByTreatmentType = (items, treatment_types) => {
  if (!treatment_types || treatment_types.length === 0) {
    return items;
  }

  return items.filter((item) => {
    const isDrug = getIsDrugItem(item);
    if (treatment_types.includes(TREATMENT_TYPE_VALUES.STANDARD_OF_CARE) && isDrug) {
      return true;
    }
    if (treatment_types.includes(TREATMENT_TYPE_VALUES.CLINICAL_TRIALS) && !isDrug) {
      return true;
    }
    return false;
  });
};

const administrationMethodMap = {
  oral_treatment: 'Oral Treatment (by mouth)',
  injection_muscle: 'Injection To Muscle',
  iv_infusion: 'IV infusion',
};

const filterByAdministrationMethod = (items, administration_methods) => {
  if (!administration_methods || administration_methods.length === 0) {
    return items;
  }

  return items.filter((item) => administration_methods.some((method) => {
    const correspondingString = administrationMethodMap[method];
    return item.treatment_administration_type.some((adminType) => adminType === correspondingString);
  }));
};

const interventionalTypeMap = {
  chemotherapy: 'Chemotherapy',
  targeted_therapy: 'Targeted therapy',
  immunotherapy: 'Immunotherapy',
  hormonal_therapy: 'Hormonal therapy',
  gene_therapy: 'Gene therapy',
  imaging: 'Imaging',
  medical_device: 'Medical device',
  vaccine: 'Vaccine',
  oncolytic_virus_therapy: 'Oncolytic virus therapy',
  radiation: 'Radiation',
  cell_therapy: 'Cell therapy',
  diagnostics: 'Diagnostics',
  surgery: 'Surgery',
  transplantation: 'Transplantation',
  general: 'General',
};

const filterByInterventionalType = (items, interventional_types) => {
  if (!interventional_types || interventional_types.length === 0) {
    return items;
  }

  return items.filter((item) => interventional_types.some((type) => { // every
    const correspondingString = interventionalTypeMap[type]?.toLowerCase();
    return item.groups.some((group) => group.toLowerCase() === correspondingString);
  }));
};

// is not applicable for TRIAL_TYPES.TREATMENT
const filterByClinicalTrialPhase = (items, clinical_trial_phases) => {
  if (!clinical_trial_phases || clinical_trial_phases.length === 0) {
    return items;
  }
  const phaseNumbers = clinical_trial_phases.map(Number);
  return items.filter((item) => getIsDrugItem(item) || item._phases.some((phase) => phaseNumbers.includes(phase)));
};

export const filterItems = (items, filter) => {
  const {
    treatment_types,
    administration_methods,
    clinical_trial_phases,
    interventional_types,
  } = filter;

  let filteredItems = filterByTreatmentType(items, treatment_types);
  filteredItems = filterByAdministrationMethod(filteredItems, administration_methods);
  filteredItems = filterByClinicalTrialPhase(filteredItems, clinical_trial_phases);
  filteredItems = filterByInterventionalType(filteredItems, interventional_types);
  return filteredItems;
};

export const formatMatchesFilterUrl = (
  treatmentType,
  routeName = ROUTE_NAME.RESULTS,
  extraParams = [],
) => preserveQueryParam(
  ROUTE_PATH[routeName],
  {
    extra: [
      [FILTER_CATEGORY.TREATMENT_TYPES, treatmentType],
      ...extraParams,
    ],
  },
);
